<div class="full-height layout-column bringoz-table">

  <div class="tr text-uppercase layout-row layout-align-start-center">

    <div class="th small text-ellipsis flex-15">
      <bringoz-button class="margin-left-20"
                      type="tertiary"
                      size="fit"
                      (onClick)="onToggleAllVisible();$event.stopPropagation();">
        <bringoz-icon [iconName]="hiddenRoutesAgentIds.length !==  agents?.length? 'eye-on' : 'eye-off'"
                      classSize="lg"
                      fill="#484848">

        </bringoz-icon>
      </bringoz-button>
    </div>

    <div class="th small text-ellipsis flex">
      {{ 'Employee' | translate }}
    </div>

  </div>

  <div class="full-height flex rows-container layout-column">
    <cdk-virtual-scroll-viewport [itemSize]="50" class="flex viewport">
      <div *cdkVirtualFor="let agent of agents; let index = index"
           layout="column"
           class="item tr md-no-proxy fade-element-in-only table-row"
           (mouseenter)="hoveredAgentId = agent.id"
           (mouseleave)="hoveredAgentId = null">

        <div class="flex layout-row layout-align-start-center">
          <div class="index-border" [style.background-color]="agentColorMap[agent.holderId]"></div>

          <div class="td large flex-15 layout-row layout-align-start-center">
<!--            <bringoz-button *ngIf="(agent.locked || hoveredAgentId === agent.id)"-->
<!--                            type="tertiary"-->
<!--                            size="fit"-->
<!--                            class="margin-right-5"-->
<!--                            [ngbTooltip]="agent.locked ? ('Unlock Agent' | translate) : ('Lock Agent' | translate)"-->
<!--                            container="body"-->
<!--                            openDelay="300"-->
<!--                            (onClick)="onLockAgentChange.emit({id: agent.id, locked: !agent.locked});$event.stopPropagation();">-->
<!--              <bringoz-icon [iconName]="agent.locked ? 'lock' : 'lock-open-outline'" classSize="md"-->
<!--                            fill="#484848"></bringoz-icon>-->
<!--            </bringoz-button>-->

<!--            <span>{{ index + 1 }}</span>-->

            <bringoz-button type="tertiary"
                            size="fit"
                            (onClick)="onToggleVisible(agent.id, !hiddenKeys[agent.id]);$event.stopPropagation();">
              <bringoz-icon [iconName]="!hiddenKeys[agent.id] ? 'eye-on' : 'eye-off'" classSize="lg" fill="#484848"></bringoz-icon>
            </bringoz-button>
          </div>

          <div class="td large flex layout-column">
            <ng-container *ngxPermissionsOnly="'schedulingProject.visitPlan.update'">
<!--              <span>{{agent.agentReference.fullName}}</span>-->
              <app-agent-itinerary-link [linkToAgentView]="true"
                                        [agent]="agent.agentReference"
                                        [isShowCopyButton]="true">
              </app-agent-itinerary-link>
            </ng-container>
            <span *ngxPermissionsExcept="'schedulingProject.visitPlan.update'" class="text-ellipsis">{{ agent.user?.firstName }} {{ agent.user?.lastName }}</span>
            <app-bringoz-tags class="margin-top-5"
                              [tags]="agent.agentReference.tags"
                              maxTags="3">
            </app-bringoz-tags>
          </div>
        </div>

      </div>
    </cdk-virtual-scroll-viewport>
  </div>

</div>
